/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

/**
 * Verify if app is running in e2e/cypress environment by checking for `window.Cypress` object. Only useful on the client.
 */
export function isCypress() {
  return (
    typeof window !== 'undefined' &&
    // @ts-expect-error
    !!window.Cypress
  )
}
